import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BreadcrumbService } from 'src/app/services/breadcrumb/breadcrumb.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Output() onLoading = new EventEmitter();

  public usuario = StorageService.getPerfilUsuario();
  public external = StorageService.getExternalAccess();

  menuItems = [];
  menuItem;
  title = '';
  isLoading = true;

  navSubscription: Subscription = null;

  constructor(
    private route: ActivatedRoute, /* INJETAR ActivatedRoute no construtor do componente */
    private router: Router,
    public breadcrumbservice: BreadcrumbService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
  ) {
    this.navSubscription = this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.updateBreadcrumb();
      }
    });
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.navSubscription?.unsubscribe();
  }


  updateBreadcrumb() {
    this.isLoading = true;
    this.onLoading.emit(true);
    this.breadcrumbservice.getBreadcrumb(this.route.root.firstChild.firstChild.firstChild.snapshot.data["FEATURE_ID"])
      .subscribe(response => {
        this.menuItems = response.slice().reverse();
        if (this.menuItems.length > 2) {
          this.title = response[1].nomeExibicao + ' / ' + response[0].nomeExibicao;
        }
        else this.title = response[0].nomeExibicao;
      },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Ocorreu um erro ao encontrar o Módulo de Menu, tente novamente.', 'OK', 3000, 'danger-snackbar');
        }).add(() => {
          this.isLoading = false;
          this.onLoading.emit(false);
        });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}

